<template>
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">Add Solar Location</h5>
            <div v-if="confirmAgreement == false">
                By adding your solar location to Solar Share you are agreeing to the following terms of use
                <ul>
                    <li>Your production data will be shared with all users of Solar Share</li>
                    <li>Your consumption data is NOT shared with Solar Share or any users</li>
                    <li>Solar Share only stores basic information about your solar location and does NOT store any of your production data</li>
                    <li>Your detailed location is never shared with Solar Share</li>
                    <li>All production data is from the Enphase system directly and is never stored within Solar Share</li>
                    <li>You must share a solar location to be able to view other solar locations</li>
                    <li>You can hide your location at any time</li>
                    <li>You can remove your location from Solar Share at any time</li>
                </ul>
                
                <div class="input-group mb-3" >                    
                    <button class="btn btn-success btn-sm me-1" @click="agreedToTerms()">I Agree</button>
                    <button class="btn btn-warning" @click="closeAddLocation()">Cancel</button>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-md-6">
                        <strong>Web Browser</strong>
                        <ol>
                            <li><a href="https://enlighten.enphaseenergy.com/">Login</a> to your Enphase account</li>
                            <li>Select the menu at the top right</li>
                            <li>Select the Account option</li>
                            <li>My Information option</li>
                            <li>Check the box that says "Create a public page for my system"</li>
                            <li>You can choose to display your system name or select "Residential System"</li>
                            <li>Press Save System Preferences</li>
                            <li>Click on the "Preview public page" link which will open your public page in a new browser window</li>
                            <li>Copy that URL into the 'Public Page URL' box below and press Search</li>
                        </ol>
                    </div>
                    <div class="col-md-6">
                        <strong>Mobile App</strong>
                        <ol>
                            <li>Open the Enphase Enlighten app</li>
                            <li>Select the menu at the bottom right</li>
                            <li>Select the Account option</li>
                            <li>My Information option</li>
                            <li>Check the box that says "Create a public page for my system"</li>
                            <li>You can choose to display your system name or select "Residential System"</li>
                            <li>Press Save System Preferences</li>
                            <li>Click on the "Preview public page" link which will open your public page in a new browser window</li>
                            <li>Copy that URL into the 'Public Page URL' box below and press Search</li>
                        </ol>
                    </div>

                    
                </div>
                <b>Note: </b>You can view the information shared with Solar Share by viewing the Public Page URL

                <div class="input-group mb-1">
                    <input type="text" class="form-control mb" placeholder="Public Page URL" v-model="locationUrl" />
                    <button class="btn btn-success btn-sm" :disabled="locationUrl == ''" @click="getSiteDetailsFromSolarId()">Search</button>
                </div>
                <span v-if="address != ''">
                    <input type="text" class="form-control mb-1" disabled="true" v-model="address" />
                    <input type="text" class="form-control mb-1" placeholder="Friendly Name (optional)" v-model="friendlyName" />
                </span>
                <div class="input-group mb-3" >
                    
                    <button class="btn btn-success btn-sm me-1" :disabled="locationUrl == '' || latitude == '' || longitude == ''" @click="addLocation()">Add Location</button>
                    <button class="btn btn-warning" @click="closeAddLocation()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pb from '../api';
import { useToast } from 'vue-toastification';
import { store } from '../store';
//import { confirm } from '@zapadale/vue3-confirm-dialog'

export default {
    name: 'AddLocation',
    data() {
        return {
            locationUrl: '',
            friendlyName: '',
            address: '',
            latitude: '',
            longitude: '',
            confirmAgreement: false
        };
    },
    async mounted() {
        
    },
    methods: {
        agreedToTerms() {
            this.confirmAgreement = true;
        },
        async getSiteDetailsFromSolarId() {
            let toast = useToast();
            store.isLoading = true;
            try {
                let id = this.getIdFromUrl(this.locationUrl);
                let urlString = `/lookupSolarId?solarId=${id}`;

                let result = await pb.send(urlString);
                if(result.isError) {
                    toast.error(result.error);
                }
                else {
                    //this.latitude = result.location.lat;
                    //this.longitude = result.location.lon;

                    console.log("Location is: " + JSON.stringify(result.location));
                    this.address = result.solarLocation.address;
                    this.latitude = result.location.lat;
                    this.longitude = result.location.lon;
                }
            }
            catch(e) {
                toast.error("Error looking up address: " + e);
            }
            finally {
                store.isLoading = false;
            }
        },
        async lookupAddress() {
            let toast = useToast();
            store.isLoading = true;
            try {
                let urlString = `/lookupAddress?address=${this.address}`;

                let result = await pb.send(urlString);
                if(result.isError) {
                    toast.error(result.error);
                }
                else {
                    this.latitude = result.location.lat;
                    this.longitude = result.location.lon;
                }
            }
            catch(e) {
                toast.error("Error looking up address: " + e);
            }
            finally {
                store.isLoading = false;
            }
        },
        async addLocation() {
            let toast = useToast();
            store.isLoading = true;
            try {
                /*
                // https://enlighten.enphaseenergy.com/mobile/ABC123/history/graph/hours?public=1
                // https://enlighten.enphaseenergy.com/pv/public_systems/ABC123/overview?preview=1
                let url = new URL(this.locationUrl.toLowerCase());
                // /mobile/ABC123/history/graph/hours
                let path = url.pathname;
                let pieces = path.split('/');
                let id = "";
                if(pieces[1] == "mobile" || pieces[1] == "web") {
                    id = pieces[2];
                }
                else {
                    id = pieces[3];
                }*/
                //let id = this.getIdFromUrl(this.locationUrl);
                //alert("ID is: " + id);

                let id = this.getIdFromUrl(this.locationUrl);

                let urlString = `/solarEndpoint?solarId=${id}`;
                let body = {
                    "friendlyName": this.friendlyName,
                    "solarId": id,
                    "latitude": this.latitude,
                    "longitude": this.longitude
                };

                let result = await pb.send(urlString, {method: "POST", body: body});
                if(result.recordAdded) {
                    // we good!
                    toast.info("Location added!");
                    this.closeAddLocation();
                }
                else if(result.isError) {
                    toast.error(result.error);
                }
            }
            catch(e) {
                toast.error("Error adding location: " + e);
            }
            finally {
                store.isLoading = false;
            }
        },
        getIdFromUrl(urlString) {
            try {
                //let url = new URL(urlString.toLowerCase());
                let url = new URL(urlString);
                // /mobile/ABC123/history/graph/hours
                let path = url.pathname;
                let pieces = path.split('/');
                let id = "";
                if(pieces[1].toLowerCase() == "mobile" || pieces[1].toLowerCase() == "web") {
                    id = pieces[2];
                }
                else {
                    id = pieces[3];
                }
                return id;
            }
            catch(e) {
                // could not parse it, maybe it is just an ID?
                if(urlString.includes("/")) {
                    // no clue what this is
                    throw "Invalid solar device URL";
                }
                return urlString;
            }
        },
        closeAddLocation() {
            this.$emit('locationAdded');
        }
    }
};
</script>

<style scoped>
.card {
    /*
    cursor: pointer;
    */
}
</style>